import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { JwtInterceptor } from './helpers/jwt.interceptor';
import { ErrorInterceptor } from './helpers/error.interceptor';
import { AppComponent } from './app.component';
import { AppConfigService } from './shared/app-config.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ContactForm } from "./login/contact-form/contact-form.component";
import { PollCardHeaderComponent } from "./poll-creation/poll-card-header/poll-card-header.component";
import { PollCreationComponent } from "./poll-creation/poll-creation.component";
import { PlurinominalInput } from "./poll-creation/plurinominal-input/plurinominal-input.component";
import { LivePollComponent } from "./poll-live/poll-live.component";
import { PollCreationFormComponent } from "./poll-creation/poll-creation-form/poll-creation-form.component";
import { VotedListComponent } from "./poll-creation/voted-list/voted-list.component";
import { TypeVoteComponent } from "./poll-creation/voted-list/type-vote/type-vote.component";
import { VotersListComponent } from "./poll-creation/voters-list/voters-list.component";
import { InputCandidateComponent } from "./poll-creation/voted-list/input-candidate/input-candidate.component";
import { InputResolutionComponent } from "./poll-creation/voted-list/input-resolution/input-resolution.component";
import { LiveResolutionComponent } from "./poll-creation/voted-list/live-resolution/live-resolution.component";
import { ConfirmationComponent } from "./poll-creation/confirmation-component/confirmation-component.component";
import { PollPlannedComponent } from "./poll-planned/poll-planned.component";
import { PollPlannedSummaryComponent } from "./poll-planned/poll-planned-summary/poll-planned-summary.component";
import { PollPlannedTimerComponent } from "./poll-planned/poll-planned-timer/poll-planned-timer.component";
import { PollPlannedCountdownComponent } from "./poll-planned/poll-planned-countdown/poll-planned-countdown.component";
import { PollPlannedList } from "./poll-planned/poll-planned-list/poll-planned-list.component";
import { PollList } from "./poll-planned/poll-list/poll-list.component";
import { PollOngoingComponent } from "./poll-ongoing/poll-ongoing.component";
import { PollOngoingSummaryComponent } from "./poll-ongoing/poll-ongoing-summary/poll-ongoing-summary.component";
import { PollOngoingTimerComponent } from "./poll-ongoing/poll-ongoing-timer/poll-ongoing-timer.component";
import { PollFinishedComponent } from "./poll-finished/poll-finished.component";
import { PollFinishedSummaryComponent } from "./poll-finished/poll-finished-summary/poll-finished-summary.component";
import { PollAuditComponent } from "./poll-audit/poll-audit.component";
import { AuditHistoryComponent } from "./poll-audit/audit-history/audit-history.component";
import { PollAuditStatusComponent } from "./poll-audit/poll-audit-status/poll-audit-status.component";
import { AuditHashComponent } from "./poll-audit/audit-hash/audit-hash.component";
import { PollResultsComponent } from "./poll-finished/result-holder/result-holder.component";
import { PollResultsResultComponent } from "./poll-finished/result-holder/poll-results-result/poll-results-result.component";
import { PollResultsListComponent } from "./poll-finished/result-holder/poll-results-list/poll-results-list.component";
import { PollResultsResolutionListComponent } from "./poll-finished/result-holder/poll-results-resolution-list/poll-results-resolution-list.component";
import { PollDashboardComponent } from "./polls-dashboard/poll-dashboard.component";
import { PollColumnComponent } from "./polls-dashboard/poll-column/poll-column.component";
import { PollDashboardItemComponent } from "./polls-dashboard/poll-dashboard-item/poll-dashboard-item.component";
import { LivePollsListComponent } from "./poll-live/live-polls-list/live-polls-list.component";
import { LiveFixedResolutionComponent } from "./poll-live/live-polls-list/live-resolution/live-resolution.component";
import { AddedResolutionComponent } from "./poll-live/live-polls-list/added-resolution/added-resolution.component";
import { LiveCandidatesListComponent } from "./poll-live/live-candidates-list/live-candidates-list.component";
import { LiveFixedCandidateComponent } from "./poll-live/live-candidates-list/live-candidates/live-candidate.component";
import { AddedCandidateComponent } from "./poll-live/live-candidates-list/added-candidate/added-candidate.component";
import { AddedCandidateInput } from "./poll-live/live-candidates-list/added-candidate/added-candidate-input/input-candidate.component";
import { LoaderComponent } from "./poll-creation/loader/loader.component";
import { HomeComponent } from "./home/home.component";
import { Offers } from "./login/offers/offers.component";
import { OffersPopup } from "./polls-dashboard/offers-popup/offers-popup.component";
import { OfferCard } from "./polls-dashboard/offer-card/offer-card.component";
import { OfferCardMain } from "./polls-dashboard/offer-card-main/offer-card-main.component";
import { WarningPopup } from "./poll-creation/warning-popup/warning-popup.component";
import { OfferDetailsPopup } from "./poll-creation/warning-popup/offer-details-popup/offer-details-popup.component";
import { SMSDetailsPopup } from "./poll-creation/warning-popup/sms-details-popup/sms-details-popup.component";
import { ExcelError } from "./poll-creation/warning-popup/excel-error-details/excel-error-details.component";
import { PollConfirmComponent } from "./poll-creation/poll-confirm-popup/poll-confirm-popup.component";
import { VotersRelaunchComponent} from "./poll-ongoing/voters-relaunch/voters-relaunch.component";
import { SuspendPopupComponent} from "./poll-ongoing/suspend-popup/suspend-popup.component";
import { ResumePopupComponent} from "./poll-ongoing/resume-popup/resume-popup.component";
import { ConfirmSuspendPopupComponent} from "./poll-ongoing/confirm-suspend-popup/confirm-suspend-popup.component";
import { ConfirmResumePopupComponent} from "./poll-ongoing/confirm-resume-popup/confirm-resume-popup.component";
import { VotersListPopupComponent } from "./popups/voters-list-popup/voters-list-popup.component";
import { AssessorsListPopupComponent } from "./popups/assessors-list-popup/assessors-list-popup.component";
import { VotersRelaunchPopupComponent } from "./popups/voters-relaunch-popup/voters-relaunch-popup.component";
import { ConvocationPopupComponent } from "./popups/convocation-popup/convocation-popup.component";
import { AssessorsRelaunchPopupComponent } from './popups/assessors-relaunch-popup/assessors-relaunch-popup.component';
import { TransferVotersPopupComponent } from './popups/transfer-voters-popup/transfer-voters-popup.component';
import { TransferAssessorsPopupComponent } from './popups/transfer-assessors-popup/transfer-assessors-popup.component';
import { ValidVoterChangesComponent } from './popups/valid-voter-changes/valid-voter-changes.component';
import { PollPagesHeader } from './poll-live/poll-pages-header/poll-pages-header.component';
import { PollOverviewHeader } from './poll-live/poll-overview-header/poll-overview-header.component';
import { SubscribeComponent } from './home/new-login/auth/inscription/inscription.component';
import { HomepagePopup } from './home/new-login/auth/homepage-popup/homepage-popup.component';
import { HotlineDetails } from './poll-creation/warning-popup/hotline-details/hotline-details.component';
import { StatusBar } from './poll-live/poll-live-shared/status-bar.component';
import { ListResultsListComponent } from './poll-finished/result-holder/list-results-list/list-results-list.component';
import { PollResultsRatureResultComponent } from './poll-finished/result-holder/poll-results-rature-result/poll-results-rature-result.component';
import { AssessorsToggle } from './poll-creation/voted-list/assessors-toggle/assessors-toggle.component';
import { AssessorsFields } from './poll-creation/voted-list/assessors-fields/assessors-fields.component';
import { InputAssessorComponent } from './poll-creation/voted-list/input-assessor/input-assessor.component';
import { BlueButtonComponent } from './shared/buttons/blue-button/blue-button.component';
import { HeadbandComponent } from './shared/headband/headband.component';
import { BuyOptionsPopupComponent } from './popups/buy-options-popup/buy-options-popup.component';
import { DisabledButtonComponent } from './shared/buttons/disabled-button/disabled-button.component';
import { WhiteDashedButtonComponent } from './shared/buttons/with-dashed-button/white-dashed-button.component';
import { AuditLogComponent } from './poll-audit/audit-log/audit-log.component';

import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';

import { ErrorComponent } from './error-view/error.component';
import { VotersDisplayComponent } from './voters-display/voters-display.component';
import { AuthModule } from '@auth0/auth0-angular';
import { AuthHttpInterceptorExtended } from './helpers/AuthHttpInterceptorExtended';
import { environment as env } from '../environments/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { DragDropDirective } from './drag-drop-directive.directive';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { I18nService } from './core/i18n.service';
import { VersionService } from './shared/version.service';
import { StoreModule } from '@ngrx/store';
import { appReducer } from './states/reducersMap';
import { ProfileComponent } from './profile/profile.component';
import { PollImportComponent } from './poll-import/poll-import.component';
import {NgOptimizedImage} from '@angular/common';
import { PollPlannedAssessorComponent } from './poll-planned-assessor/poll-planned-assessor.component';
import { AssessorValidationHeaderComponent } from './poll-planned-assessor/assessor-validation-header/assessor-validation-header.component';
import { PollOngoingAssessorComponent } from './poll-ongoing-assessor/poll-ongoing-assessor.component';
import { ChangeVoterComponent } from './poll-ongoing/change-voter/change-voter.component';
import { ValidChangesComponent } from './poll-ongoing/change-voter/valid-changes/valid-changes.component';
import { AssessorChangeComponentComponent } from './poll-planned/assessor-change-component/assessor-change-component.component';
import { PollPreviewComponent } from './poll-preview/poll-preview.component';
import {NgCircleProgressModule} from 'ng-circle-progress';
import { QuestionsPreviewComponent } from './poll-preview/questions-preview/questions-preview.component';
import { PreviewResolutionComponent } from './poll-preview/questions-preview/preview-resolution/preview-resolution.component';
import { PreviewResolutionItemComponent } from './poll-preview/questions-preview/preview-resolution-item/preview-resolution-item.component';
import { PreviewResolutinsChoicesComponent } from './poll-preview/questions-preview/preview-resolutins-choices/preview-resolutins-choices.component';
import { PreviewEventItemComponent } from './poll-preview/questions-preview/preview-event-item/preview-event-item.component';
import { CandidatesControllerComponent } from './poll-preview/questions-preview/candidates-controller/candidates-controller.component';
import { CandidatesItemComponent } from './poll-preview/questions-preview/candidates-controller/candidates-item/candidates-item.component';
import { ListCandidatesControllerComponent } from './poll-preview/questions-preview/list-candidates-controller/list-candidates-controller.component';
import { ListCandidateItemComponent } from './poll-preview/questions-preview/list-candidates-controller/list-candidate-item/list-candidate-item.component';
import { PlurionominalMinInputComponent } from './poll-creation/plurionominal-min-input/plurionominal-min-input.component';
import { PapCreationComponent } from './pap-creation/pap-creation.component';
import {MatRadioButton, MatRadioGroup} from '@angular/material/radio';
import {MatCell, MatCellDef, MatColumnDef, MatHeaderCell, MatHeaderCellDef, MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef, MatTable} from '@angular/material/table';
import { CommunicationsComponent } from './poll-creation/communications/communications.component';
import { CseHeaderComponent } from './poll-finished/cse-header/cse-header.component';
import { ProgressBarModule } from 'primeng/progressbar';
import { AccordionModule } from 'primeng/accordion';
import { PanelModule } from 'primeng/panel';
import { InputOtpModule } from 'primeng/inputotp';
import { TableModule } from 'primeng/table';
import { DropdownModule } from 'primeng/dropdown';
import { TooltipModule } from 'primeng/tooltip';
import { V8teButtonComponent } from './shared/buttons/v8te-button/v8te-button.component';
import { V8teActiveButtonComponent } from './shared/buttons/v8te-active-button/v8te-active-button.component';
import { CseResultsComponent } from './poll-finished/cse-results/cse-results.component';
import { CseCategoryComponent } from './poll-finished/cse-results/cse-category/cse-category.component';
import { CustomTagComponent } from './shared/tag/tag.component';
import { InputNumberModule } from 'primeng/inputnumber';
import { PapHeaderComponent } from './pap-creation/pap-header/pap-header.component';
import { PapBodyComponent } from './pap-creation/pap-body/pap-body.component';
import { PapInformationComponent } from './pap-creation/pap-body/pap-information/pap-information.component';
import { PapEmployerComponent } from './pap-creation/pap-body/pap-employer/pap-employer.component';
import { PapUnionComponent } from './pap-creation/pap-body/pap-union/pap-union.component';
import { UnionComponent } from './pap-creation/pap-body/pap-union/union/union.component';
import { PapLengthComponent } from './pap-creation/pap-body/pap-length/pap-length.component';
import { PapPeriodComponent } from './pap-creation/pap-body/pap-period/pap-period.component';
import { PapHeadcountComponent } from './pap-creation/pap-body/pap-headcount/pap-headcount.component';
import { PapCollegeComponent } from './pap-creation/pap-body/pap-college/pap-college.component';
import { OneCollegeComponent } from './pap-creation/pap-body/pap-college/college/college.component';
import { PapYearComponent } from './pap-creation/pap-body/pap-year/pap-year.component';
import { PapApplicationComponent } from './pap-creation/pap-body/pap-application/pap-application.component';
import { PapVerificationComponent } from './pap-creation/pap-verification/pap-verification.component';
import { PapInformationVerificationComponent } from './pap-creation/pap-verification/pap-information-verification/pap-information-verification.component';
import { PapEmployerVerificationComponent } from './pap-creation/pap-verification/pap-employer-verification/pap-employer-verification.component';
import { PapUnionVerificationComponent } from './pap-creation/pap-verification/pap-union-verification/pap-union-verification.component';
import { UnionVerificationComponent } from './pap-creation/pap-verification/pap-union-verification/union-verification/union-verification.component';
import { PapLengthVerificationComponent } from './pap-creation/pap-verification/pap-length-verification/pap-length-verification.component';
import { PapPeriodVerificationComponent } from './pap-creation/pap-verification/pap-period-verification/pap-period-verification.component';
import { PapHeadcountVerificationComponent } from './pap-creation/pap-verification/pap-headcount-verification/pap-headcount-verification.component';
import { PapCollegeVerificationComponent } from './pap-creation/pap-verification/pap-college-verification/pap-college-verification.component';
import { OneCollegeVerificationComponent } from './pap-creation/pap-verification/pap-college-verification/college-verification/college-verification.component';
import { PapYearVerificationComponent } from './pap-creation/pap-verification/pap-year-verification/pap-year-verification.component';
import { PapApplicationVerificationComponent } from './pap-creation/pap-verification/pap-application-verification/pap-application-verification.component';
import { TagComponent } from './pap-creation/pap-verification/misc/tag/tag.component';
import { PapCompletedComponent } from './pap-creation/pap-completed/pap-completed.component';
import { CerfaBodyComponent } from './pap-creation/cerfa-body/cerfa-body.component';
import { CerfaInformationComponent } from './pap-creation/cerfa-body/cerfa-information/cerfa-information.component';
import { CerfaLengthComponent } from './pap-creation/cerfa-body/cerfa-length/cerfa-length.component';
import { CerfaSiretsComponent } from './pap-creation/cerfa-body/cerfa-sirets/cerfa-sirets.component';
import { CerfaListsComponent } from './pap-creation/cerfa-body/cerfa-lists/cerfa-lists.component';
import { CerfaContactComponent } from './pap-creation/cerfa-body/cerfa-contact/cerfa-contact.component';
import { CerfaContactVerificationComponent } from './pap-creation/cerfa-verification/cerfa-contact-verification/cerfa-contact-verification.component';
import { CerfaInformationVerificationComponent } from './pap-creation/cerfa-verification/cerfa-information-verification/cerfa-information-verification.component';
import { CerfaLengthVerificationComponent } from './pap-creation/cerfa-verification/cerfa-length-verification/cerfa-length-verification.component';
import { CerfaListsVerificationComponent } from './pap-creation/cerfa-verification/cerfa-lists-verification/cerfa-lists-verification.component';
import { CerfaSiretsVerificationComponent } from './pap-creation/cerfa-verification/cerfa-sirets-verification/cerfa-sirets-verification.component';
import { CerfaVerificationComponent } from './pap-creation/cerfa-verification/cerfa-verification.component';
import { CsePollCreationComponent } from './pap-creation/cse-poll-creation/cse-poll-creation.component';
import { PollCreationRoundComponent } from './pap-creation/cse-poll-creation/poll-creation-round/poll-creation-round.component';
import { PollCreationHeadcountComponent } from './pap-creation/cse-poll-creation/poll-creation-headcount/poll-creation-headcount.component';
import { PollCreationPeriodComponent } from './pap-creation/cse-poll-creation/poll-creation-period/poll-creation-period.component';
import { PollCreationContextComponent } from './pap-creation/cse-poll-creation/poll-creation-context/poll-creation-context.component';
import { PollCreationSendingModeComponent } from './pap-creation/cse-poll-creation/poll-creation-sending-mode/poll-creation-sending-mode.component';
import { PollCreationSecurityComponent } from './pap-creation/cse-poll-creation/poll-creation-security/poll-creation-security.component';
import { PollCreationSenderComponent } from './pap-creation/cse-poll-creation/poll-creation-sender/poll-creation-sender.component';
import { PollCreationTitleComponent } from './pap-creation/cse-poll-creation/poll-creation-title/poll-creation-title.component';
import { PollCreationImportComponent } from './pap-creation/cse-poll-creation/poll-creation-import/poll-creation-import.component';
import { ImportTableComponent } from './pap-creation/cse-poll-creation/poll-creation-import/import-table/import-table.component';
import { VotersDeletePopupComponent } from './popups/voters-delete-popup/voters-delete-popup.component';
import { VotersAddPopupComponent } from './popups/voters-add-popup/voters-add-popup.component';
import { PollCreationUnionComponent } from './pap-creation/cse-poll-creation/poll-creation-union/poll-creation-union.component';
import { VotersValidatePopupComponent } from './popups/voters-validate-popup/voters-validate-popup.component';
import { UnionTableComponent } from './pap-creation/cse-poll-creation/poll-creation-union/union-table/union-table.component';
import { UnionListComponent } from './pap-creation/cse-poll-creation/poll-creation-union/union-list/union-list.component';
import { CollegeCandidatesComponent } from './pap-creation/cse-poll-creation/poll-creation-union/college-candidates/college-candidates.component';
import { PollAssessorsComponent } from './pap-creation/cse-poll-creation/poll-creation-union/poll-assessors/poll-assessors.component';
import { RepresentativePopupComponent } from './popups/representative-popup/representative-popup.component';
import { AssessorsClosingComponent } from './pap-creation/assessors-closing/assessors-closing.component';
import { AssessorsDetailsComponent } from './pap-creation/assessors-closing/assessors-details/assessors-details.component';
import { AssessorsInviteComponent } from './pap-creation/assessors-closing/assessors-invite/assessors-invite.component';
import { AssessorsTrackComponent } from './pap-creation/assessors-closing/assessors-track/assessors-track.component';
import { AssessorsStartComponent } from './pap-creation/assessors-closing/assessors-start/assessors-start.component';
import { AssessorsVotesComponent } from './pap-creation/assessors-closing/assessors-votes/assessors-votes.component';
import { AssessorsStopComponent } from './pap-creation/assessors-closing/assessors-stop/assessors-stop.component';
import { AssessorsChangeMailPopupComponent } from './popups/assessors-change-mail-popup/assessors-change-mail-popup.component';
import { AssessorsUnsealComponent } from './pap-creation/assessors-closing/assessors-unseal/assessors-unseal.component';
import { AssessorsResultComponent } from './pap-creation/assessors-closing/assessors-result/assessors-result.component';
import { AssessorsCloseComponent } from './pap-creation/assessors-closing/assessors-close/assessors-close.component';
import { SuspendedAccountComponent } from './suspended-account/suspended-account.component';
import { SuspendedTableComponent } from './suspended-account/suspended-table/suspended-table.component';
import { RolesComponent } from './roles/roles.component';
import { RolesTableComponent } from './roles/roles-table/roles-table.component';
import { ResendInvitePopupComponent } from './roles/resend-invite-popup/resend-invite-popup.component';
import { ResentInvitePopupComponent } from './roles/resent-invite-popup/resent-invite-popup.component';
import { DisablePopupComponent } from './roles/disable-popup/disable-popup.component';
import { DisabledPopupComponent } from './roles/disabled-popup/disabled-popup.component';
import { AddUserPopupComponent } from './roles/add-user-popup/add-user-popup.component';
import { AddedUserPopupComponent } from './roles/added-user-popup/added-user-popup.component';
import { ChangeProfilePopupComponent } from './roles/change-profile-popup/change-profile-popup.component';
import { ChangedProfilePopupComponent } from './roles/changed-profile-popup/changed-profile-popup.component';
import { PapReadyComponent } from './pap-creation/pap-ready/pap-ready.component';
import { SingleAssessorsRelaunchPopupComponent } from './popups/single-assessors-relaunch-popup/single-assessors-relaunch-popup.component';
import { AddUserFailedPopupComponent } from './roles/add-user-failed-popup/add-user-failed-popup.component';
import { DeleteUserPopupComponent } from './roles/delete-user-popup/delete-user-popup.component';
import { EnablePopupComponent } from './roles/enable-popup/enable-popup.component';
import { EnabledPopupComponent } from './roles/enabled-popup/enabled-popup.component';

@NgModule({
  declarations: [
    AppComponent,
    PollCreationComponent,
    LivePollComponent,
    PollCreationFormComponent,
    PollPlannedComponent,
    VotedListComponent,
    TypeVoteComponent,
    VotersListComponent,
    InputCandidateComponent,
    InputResolutionComponent,
    LiveResolutionComponent,
    ConfirmationComponent,
    PollPlannedSummaryComponent,
    PollPlannedTimerComponent,
    PollPlannedCountdownComponent,
    PollPlannedList,
    PollList,
    PollOngoingComponent,
    PollOngoingSummaryComponent,
    PollOngoingTimerComponent,
    AddedResolutionComponent,
    PollFinishedComponent,
    PollFinishedSummaryComponent,
    PollAuditComponent,
    AuditHistoryComponent,
    PollAuditStatusComponent,
    AuditHashComponent,
    AuditLogComponent,
    PollResultsComponent,
    PollResultsResultComponent,
    PollResultsListComponent,
    PollResultsResolutionListComponent,
    PollDashboardComponent,
    PollColumnComponent,
    PollDashboardItemComponent,
    ErrorComponent,
    LivePollsListComponent,
    LiveFixedResolutionComponent,
    VotersDisplayComponent,
    LiveCandidatesListComponent,
    LiveFixedCandidateComponent,
    AddedCandidateComponent,
    AddedCandidateInput,
    LoaderComponent,
    DragDropDirective,
    HomeComponent,
    PollCardHeaderComponent,
    ContactForm,
    PlurinominalInput,
    Offers,
    OffersPopup,
    OfferCard,
    OfferCardMain,
    PollConfirmComponent,
    VotersRelaunchComponent,
    SuspendPopupComponent,
    ConfirmSuspendPopupComponent,
    ResumePopupComponent,
    ConfirmResumePopupComponent,
    VotersListPopupComponent,
    AssessorsListPopupComponent,
    VotersRelaunchPopupComponent,
    ConvocationPopupComponent,
    AssessorsRelaunchPopupComponent,
    TransferVotersPopupComponent,
    TransferAssessorsPopupComponent,
    ValidVoterChangesComponent,
    WarningPopup,
    OfferDetailsPopup,
    SubscribeComponent,
    ExcelError,
    SMSDetailsPopup,
    HomepagePopup,
    PollPagesHeader,
    PollOverviewHeader,
    HotlineDetails,
    ListResultsListComponent,
    PollResultsRatureResultComponent,
    StatusBar,
    AssessorsToggle,
    AssessorsFields,
    InputAssessorComponent,
    BlueButtonComponent,
    HeadbandComponent,
    BuyOptionsPopupComponent,
    DisabledButtonComponent,
    WhiteDashedButtonComponent,
    ProfileComponent,
    PollImportComponent,
    PollPlannedAssessorComponent,
    AssessorValidationHeaderComponent,
    PollOngoingAssessorComponent,
    ChangeVoterComponent,
    ValidChangesComponent,
    AssessorChangeComponentComponent,
    PollPreviewComponent,
    QuestionsPreviewComponent,
    PreviewResolutionComponent,
    PreviewResolutionItemComponent,
    PreviewResolutinsChoicesComponent,
    PreviewEventItemComponent,
    CandidatesControllerComponent,
    CandidatesItemComponent,
    ListCandidatesControllerComponent,
    ListCandidateItemComponent,
    PlurionominalMinInputComponent,
    CommunicationsComponent,
    CseHeaderComponent,
    V8teButtonComponent,
    V8teActiveButtonComponent,
    CseResultsComponent,
    CseCategoryComponent,
    CustomTagComponent,
    PapCreationComponent,
    PapHeaderComponent,
    PapBodyComponent,
    PapInformationComponent,
    PapEmployerComponent,
    PapUnionComponent,
    UnionComponent,
    PapLengthComponent,
    PapPeriodComponent,
    PapHeadcountComponent,
    PapCollegeComponent,
    OneCollegeComponent,
    PapYearComponent,
    PapApplicationComponent,
    PapVerificationComponent,
    PapInformationVerificationComponent,
    PapEmployerVerificationComponent,
    PapUnionVerificationComponent,
    UnionVerificationComponent,
    PapLengthVerificationComponent,
    PapPeriodVerificationComponent,
    PapHeadcountVerificationComponent,
    PapCollegeVerificationComponent,
    OneCollegeVerificationComponent,
    PapYearVerificationComponent,
    PapApplicationVerificationComponent,
    TagComponent,
    PapCompletedComponent,
    CerfaBodyComponent,
    CerfaInformationComponent,
    CerfaLengthComponent,
    CerfaSiretsComponent,
    CerfaListsComponent,
    CerfaContactComponent,
    CerfaContactVerificationComponent,
    CerfaInformationVerificationComponent,
    CerfaLengthVerificationComponent,
    CerfaListsVerificationComponent,
    CerfaSiretsVerificationComponent,
    CerfaVerificationComponent,
    CsePollCreationComponent,
    PollCreationRoundComponent,
    PollCreationHeadcountComponent,
    PollCreationPeriodComponent,
    PollCreationContextComponent,
    PollCreationSendingModeComponent,
    PollCreationSecurityComponent,
    PollCreationSenderComponent,
    PollCreationTitleComponent,
    PollCreationImportComponent,
    ImportTableComponent,
    VotersDeletePopupComponent,
    VotersAddPopupComponent,
    PollCreationUnionComponent,
    VotersValidatePopupComponent,
    UnionTableComponent,
    UnionListComponent,
    CollegeCandidatesComponent,
    PollAssessorsComponent,
    RepresentativePopupComponent,
    AssessorsClosingComponent,
    AssessorsDetailsComponent,
    AssessorsInviteComponent,
    AssessorsTrackComponent,
    AssessorsStartComponent,
    AssessorsVotesComponent,
    AssessorsStopComponent,
    AssessorsChangeMailPopupComponent,
    AssessorsUnsealComponent,
    AssessorsResultComponent,
    AssessorsCloseComponent,
    SuspendedAccountComponent,
    SuspendedTableComponent,
    RolesComponent,
    RolesTableComponent,
    ResendInvitePopupComponent,
    ResentInvitePopupComponent,
    DisablePopupComponent,
    DisabledPopupComponent,
    AddUserPopupComponent,
    AddedUserPopupComponent,
    ChangeProfilePopupComponent,
    ChangedProfilePopupComponent,
    PapReadyComponent,
    SingleAssessorsRelaunchPopupComponent,
    AddUserFailedPopupComponent,
    DeleteUserPopupComponent,
    EnablePopupComponent,
    EnabledPopupComponent
  ],
  imports: [
    ProgressBarModule,
    AccordionModule,
    PanelModule,
    InputOtpModule,
    TableModule,
    InputNumberModule,
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    AuthModule.forRoot({
      ...env.auth,
      httpInterceptor: {
        ...env.httpInterceptor,
      },
    }),
    BrowserAnimationsModule,
    MatButtonToggleModule,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
    MatInputModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    StoreModule.forRoot(appReducer.reducers, {metaReducers: appReducer.metaReducers}),
    NgOptimizedImage,
    NgCircleProgressModule,
    MatRadioGroup,
    MatRadioButton,
    MatTable,
    MatHeaderCellDef,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatCell,
    MatHeaderRowDef,
    MatRowDef,
    MatHeaderRow,
    MatRow,
    DropdownModule,
    TooltipModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptorExtended,
      multi: true,
    },
    {
      provide: Window,
      useValue: window,
    },
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [AppConfigService],
      useFactory: (appConfigService: AppConfigService) => {
        return () => {
          // Make sure to return a promise!
          return appConfigService.loadAppConfig();
        };
      },
    },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'fill' },
    },
    I18nService,
    Title,
    VersionService
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(private i18nService: I18nService) {}
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
